import { Localized } from "@fluent/react"
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Alert, Typography } from "@mui/material"
import { showSuccess } from "../../notifications/notificationsSlice";
import { resetAppUserPassword } from "../administration";
import { useAppDispatch } from "../../../app/hooks";
import { useState } from "react";
import { YesButton } from "../../../app/components/YesButton";
import { CancelButton } from "../../../app/components/CancelButton";

export interface ResetPasswordDialogProps {
    email: string;
    onSuccessfullySaved: (updated: any) => void;
    onCancel: () => void
}

export const ResetPasswordDialog = ({ email, onSuccessfullySaved, onCancel }: ResetPasswordDialogProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [serverError, setServerError] = useState(""); 

    const handleSubmitClick = async() => {
        try {
            setLoading(true)
            await dispatch(resetAppUserPassword({ email })).unwrap();

            dispatch(showSuccess("saved"))
            onSuccessfullySaved({ status: "INVITED" });
        } catch (error) {
            setServerError("error");
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="user-reset-password-dialog-title">
                    <span>_Zresetuj hasło</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert
                        severity="info"
                        variant="outlined"
                        sx={{
                            mb: 2,
                            mt: 2,
                            alignItems: "flex-start",
                            "& .MuiAlert-message": {
                                width: "100%",
                            },
                        }}
                    >
                        <Typography variant="body2">
                            <Localized id="user-reset-password-dialog-alert">
                                <span>_Czy na pewno chcesz zresetować hasło wskazanego użytkownika?</span>
                            </Localized>
                        </Typography>
                    </Alert>
                </DialogContentText>

                {serverError && (
                    <Alert sx={{ marginTop: 1 }} severity="error">
                        <Localized id={serverError}>
                            <span style={{ whiteSpace: 'pre-line' }}>{serverError}</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <YesButton
                    loading={loading}
                    onClick={handleSubmitClick}
                />
                <CancelButton
                    loading={loading}
                    onClick={onCancel}
                />
            </DialogActions>
        </>
    )
}